<div class="pointCF__field pointCF__field--expandable">
  <div class="pointCF__content">
    <pp-rich-text
      class="richText__container"
      [ppId]="ppField.customFieldTemplateId"
      [ppCanEdit]="ppCanEdit"
      [ppValue]="{ richText: ppValue?.richTextComponent, plainText: ppValue?.plainText }"
      [ppWorkspaceId]="ppWorkspaceId"
      ppPlaceholder="Enter text..."
      (ppUpdate)="updateField($event)"
      [ppRichTextOptions]="richTextOptions"
      [ppIsLocked]="ppLocked"
    ></pp-rich-text>
  </div>
</div>
